/**
 * AffiliateRibbon — Global 40px top strip.
 * Replaces the existing StorefrontHeader. Fixed at top:67px (below nav).
 * Renders nothing when storefront is null.
 */
import React, { useContext } from 'react';
import Contexts from '../../contexts/Contexts';

export const RIBBON_HEIGHT = 40;

const AffiliateRibbon: React.FC = () => {
  const { storefront } = useContext(Contexts);
  if (!storefront) return null;

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 67,
          left: 0,
          right: 0,
          height: RIBBON_HEIGHT,
          background: storefront.primary_color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          zIndex: 998,
          padding: '0 16px',
        }}
      >
        {storefront.logo_url && (
          <img
            src={storefront.logo_url}
            alt={storefront.display_name}
            style={{ height: 22, maxWidth: 80, objectFit: 'contain' }}
          />
        )}
        <span style={{
          color: '#fff',
          fontSize: 13,
          fontWeight: 700,
          lineHeight: 1,
        }}>
          {storefront.display_name}
        </span>
        {storefront.tagline && (
          <span style={{
            color: '#fff',
            opacity: 0.7,
            fontSize: 12,
            fontWeight: 400,
          }}>
            · {storefront.tagline}
          </span>
        )}
      </div>
      {/* Spacer so content doesn't hide under the ribbon */}
      <div style={{ height: RIBBON_HEIGHT }} />
    </>
  );
};

export default AffiliateRibbon;
